import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinnerThird as fadSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import {
  faCalendarCircleUser as farCalendarCircleUser,
  faChevronRight as farChevronRight,
  faExternalLink as farExternalLink,
  faFaceMeh as farFaceMeh,
  faFaceSadSweat as farFaceSadSweat,
  faFaceSmile as farFaceSmile,
  faHourglassEnd as farHourglassEnd,
  faHourglassStart as farHourglassStart,
  faSquareXmark as farSquareXmark,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faCalendar,
  faCircleCheck,
  faCircleXmark,
  faFileArrowUp,
  faHexagonExclamation,
  faPartyHorn,
  faSpinnerThird,
  faXmark,
  faAirplay as fasAirplay,
  faAngleDown as fasAngleDown,
  faAngleLeft as fasAngleLeft,
  faAngleRight as fasAngleRight,
  faAngleUp as fasAngleUp,
  faArrowDownLeft as fasArrowDownLeft,
  faArrowDownRight as fasArrowDownRight,
  faArrowLeftLong as fasArrowLeftLong,
  faArrowRight as fasArrowRight,
  faArrowUpLeft as fasArrowUpLeft,
  faArrowUpRight as fasArrowUpRight,
  faArrowsUpDownLeftRight as fasArrowsUpDownLeftRight,
  faCheck as fasCheck,
  faCheckCircle as fasCheckCircle,
  faChevronRight as fasChevronRight,
  faClock as fasClock,
  faDiamondExclamation as fasDiamondExclamation,
  faEllipsis as fasEllipsis,
  faEyeSlash as fasEyeSlash,
  faFaceMeh as fasFaceMeh,
  faFaceSadSweat as fasFaceSadSweat,
  faFaceSmile as fasFaceSmile,
  faGear as fasGear,
  faHandHoldingHeart as fasHandHoldingHeart,
  faHandsHoldingHeart as fasHandsHoldingHeart,
  faImageUser as fasImageUser,
  faInfoCircle as fasInfoCircle,
  faLightbulb as fasLightbulb,
  faLightbulbOn as fasLightbulbOn,
  faLocationDot as fasLocationDot,
  faLock as fasLock,
  faMemo as fasMemo,
  faMessage as fasMessage,
  faMicrophone as fasMicrophone,
  faMicrophoneSlash as fasMicrophoneSlash,
  faMugHot as fasMugHot,
  faPaperPlaneTop as fasPaperPlaneTop,
  faPause as fasPause,
  faPlay as fasPlay,
  faRepeat as fasRepeat,
  faSparkles as fasSparkles,
  faUser as fasUser,
  faVideo as fasVideo,
  faVideoSlash as fasVideoSlash,
  faVolume as fasVolume,
  faVolumeOff as fasVolumeOff,
  faWarning as fasWarning,
  faWifiExclamation as fasWifiExclamation,
} from '@fortawesome/pro-solid-svg-icons';

export function addAppIconsToLibrary() {
  library.add(
    fadSpinnerThird,
    farCalendarCircleUser,
    farChevronRight,
    farExternalLink,
    farFaceMeh,
    farFaceSadSweat,
    farFaceSmile,
    farHourglassEnd,
    farHourglassStart,
    farSquareXmark,
    fasAirplay,
    fasArrowDownLeft,
    fasArrowDownRight,
    fasArrowUpLeft,
    fasArrowUpRight,
    fasCheckCircle,
    fasCheck,
    fasChevronRight,
    fasDiamondExclamation,
    fasEllipsis,
    fasFaceMeh,
    fasFaceSadSweat,
    fasFaceSmile,
    fasGear,
    fasHandsHoldingHeart,
    fasHandHoldingHeart,
    fasImageUser,
    fasInfoCircle,
    fasLightbulb,
    fasLightbulbOn,
    farSquareXmark,
    fasLock,
    fasMessage,
    fasMicrophone,
    fasMicrophoneSlash,
    fasPaperPlaneTop,
    fasPause,
    fasPlay,
    fasSparkles,
    fasUser,
    fasVideo,
    fasVideoSlash,
    fasVolume,
    fasVolumeOff,
    fasWarning,
    fasArrowLeftLong,
    fasArrowRight,
    fasAngleUp,
    fasAngleDown,
    fasAngleLeft,
    fasAngleRight,
    fasWifiExclamation,
    fasArrowsUpDownLeftRight,
    fasEyeSlash,
    fasMemo,
    fasMugHot,
    fasClock,
    fasLocationDot,
    fasRepeat,
    faCalendar,

    // placeholders, until Sprout has been updated to include these
    faCircleCheck,
    faCircleXmark,
    faFileArrowUp,
    faHexagonExclamation,
    faPartyHorn,
    faSpinnerThird,
    faXmark,
  );
}
